import React, { useState } from 'react'
// @ts-ignore
import { Region, transformRegionToMap, useWindowSize } from 'msp-integrations'
import { Icons, ShowOnMobile } from '../../..'
import NavItemComponentTypes from './NavItem.types'

const NavItemComponent = ({
  data,
  regions,
  NavItemLink,
  componentID,
  className,
  onItemMouseEnter,
  ...rest
}: NavItemComponentTypes) => {
  const [isOpen, setIsOpen] = useState(false)
  const { width, breakpoints } = useWindowSize()

  const regionNavItems = transformRegionToMap(regions).get('navigationItems')
  const hasSubcategories = regionNavItems?.components
  const isMobile = width && width < breakpoints.md
  const isAccordionMobile = !!(isMobile && hasSubcategories)

  return (
    <li
      className={`list-navitem ${
        (hasSubcategories && 'parent-navitem') || ''
      } ${className || ''}`}
      onMouseEnter={() =>
        onItemMouseEnter &&
        onItemMouseEnter({
          children: regionNavItems,
          selectedItemId: componentID
        })
      }
    >
      {(isAccordionMobile && (
        <>
          <a
            onClick={(e) => setIsOpen(!isOpen)}
            className={`navitem-${data.colorScheme} ${data.cssClass || ''} `}
          >
            {data.textContent}
            <Icons
              iconName={isOpen ? 'ArrowUp' : 'ArrowDown'}
              height='32px'
              width='40px'
              color='#FFFFFF'
            />
          </a>
        </>
      )) || (
        <NavItemLink
          colorScheme={data.colorScheme}
          cssClass={data.cssClass}
          link={data.link}
          linkType={data.linkType}
          closeFlyout={data.closeFlyout}
          {...rest}
        >
          {data.textContent}
        </NavItemLink>
      )}
      {hasSubcategories && (
        <ShowOnMobile>
          <ul
            className={`mobile-subcategories-wrapper ${
              (isOpen && 'is-open') || ''
            }`}
          >
            <Region
              region={regionNavItems}
              noWrapper
              {...{ closeFlyout: data.closeFlyout }}
            />
          </ul>
        </ShowOnMobile>
      )}
    </li>
  )
}

export default NavItemComponent
